import type { FormValue, Question } from './types';

const hasMeaningfulAnswer = (value: FormValue | undefined): boolean => {
  if (value === undefined || value === null || value === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
};

/** Blank policy from top-level ``question_db.unanswered_value`` only. */
export function getUnansweredValue(
  question: Question | undefined
): string | undefined {
  return question?.unanswered_value;
}

/** Schema answer label blank stands in for, when not mechanical ``""``. */
export function resolveBlankSchemaDefault(
  question: Question | undefined
): string | undefined {
  const value = getUnansweredValue(question);
  if (value == null || value === '') return undefined;
  return value;
}

/**
 * Answer used when walking schema ``subitems`` for visibility / validation.
 * Unset blanks with a schema default expand that branch without persisting a
 * synthetic answer.
 */
export function resolveEffectiveAnswerForSubitems(
  question: Question | undefined,
  value: FormValue | undefined
): FormValue | undefined {
  if (hasMeaningfulAnswer(value)) return value;
  return resolveBlankSchemaDefault(question);
}

/**
 * Whether a schema value may be omitted from partial ``radio-option`` /
 * ``OASISYesNoCheckbox`` layouts.
 *
 * Only when top-level ``unanswered_value`` is a non-empty schema label.
 */
export function isOmittableBlankDefault(
  question: Question | undefined,
  schemaValue: string
): boolean {
  const blankDefault = resolveBlankSchemaDefault(question);
  if (blankDefault == null) return false;
  return schemaValue === blankDefault;
}
